import $        from 'jquery';
import template from './template.hbs';
import Step     from '../../classes/step';

export default new Step({
  $el: $('<div class="form-step step-success" />'),
  template
});
